import {Concept} from 'types';
import type {TypedSchema} from 'schemaDefinition/types';
import {Separator} from 'schemaDefinition/types';
import type {AgentCorporation} from 'api';
import {agentBAREParts} from './parts';

export const agentCorporationSchema: TypedSchema<AgentCorporation> = {
  name: 'corporation',
  key: 'corporation',
  parts: [
    {...Separator('card', 'line'), titleKey: 'nameVariants'},
    {
      type: 'nameVariant',
      agentType: Concept.corporation,
      name: 'nameVariants',
      cardinality: 'multiple',
      required: true,
    },
    {
      type: 'text',
      name: 'subsidiary',
      cardinality: 'multiple',
      readonly: true,
    },
    Separator('card', 'line'),
    [...agentBAREParts],
    {
      type: 'linkedLiterary',
      name: 'links',
      key: 'links',
      cardinality: 'multiple',
      //linkPropRequired: 'should',
      roleCodelistId: 'corporation.linkedRole',
    },

    Separator('line', 'line'),
    [
      {
        type: 'yearOrDate',
        name: 'validFrom',
        validation: [
          {
            max: {$ref: ':validTo'},
            messageKey: 'birthBeforeDeath',
          },
        ],
      },
      {
        type: 'yearOrDate',
        name: 'validTo',
        validation: {
          min: {$ref: ':validFrom'},
          messageKey: 'deathAfterBirth',
        },
      },
    ],
    {
      type: 'textarea',
      name: 'externalComments',
      maxLength: 5000,
    },
    {...Separator('card', 'line'), titleKey: 'internalComments'},
    {
      type: 'textarea',
      name: 'internalComments',
      maxLength: 5000,
    },
  ],
};
